import { EyeIcon, TrashIcon } from '@heroicons/react/outline';
import React, { useState, useEffect } from 'react'
import { Chart } from "react-google-charts";
import ClientService from '../../../services/ClientService';
import DashboardService from '../../../services/DashboardService';

import Table from '../../common/Table/Table';
import { COLUMNS } from './columns'
import CalendarService from "../../../services/CalendarService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import AddUserButton from '../../common/AddUserButton/AddUserButton';
import Modal from '../../common/Modal/Modal';
import ClientsForm from '../../forms/ClientsForm/ClientsForm';

const MySwal = withReactContent(Swal)


const Dashboard = () => {

    const [shouldLoad, setShouldLoad] = useState(true)
    const [clientsData, setClientsData] = useState(null)
    const [clientsNumberData, setClientsNumberData] = useState(null)
    const [plansNumberData, setPlansNumberData] = useState(null)
    const [email, setEmail] = useState('');
    const [hasError, setHasError] = useState(false);
    const [isOpen, setIsOpen] = useState(false)
    const [userData, setUserData] = useState({})
    const [buttonText, setButtonText] = useState('Dodaj Klijenta')
    const [modalTitle, setModalTitle] = useState('')

    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false)
            getClients();
            getNumberOfClients();
            getNumberOfPlans();
        }
    }, [shouldLoad])




    const formValues = { email };


    const isNullOrWhitespace = value => {
        if (value instanceof String) {
            if (!value || value.trim() === '') {
                return true;
            }
        }

        return false;
    }

    const handleFormSubmit = e => {
        e.preventDefault();
        if (isNullOrWhitespace(email)) {
            setHasError(true);
        } else {
            CalendarService.sendInvite(formValues).then(() => {
                MySwal.fire({
                    title: "Invite sent",
                    showCancelButton: true,
                    showDenyButton: false,
                    showConfirmButton: false,
                    cancelButtonText: `Close`,
                })
            });
        }
    }

    const getClients = () => {
        ClientService.getClientsThatNeedAPlan().then((response) => {
            setClientsData(response.data);
        });
    };

    const getNumberOfClients = () => {
        DashboardService.getNumberOfClients().then((response) => {
            var res = response.data.map(x => { return [x.name, x.value] });
            setClientsNumberData(barChartClientsLabel.concat(res));
        });
    };

    const getNumberOfPlans = () => {
        DashboardService.getNumberOfPlans().then((response) => {
            var res = response.data.map(x => { return [x.name, x.value] });
            setPlansNumberData(barChartPlansLabel.concat(res));
        });
    };

    const viewMeasurements = (id) => {
        window.open("/#/home/measurements/" + id)
    }

    const viewPlans = (id) => {
        window.open("/#/home/plan-history/" + id)
    }

    const createPlan = (id) => {
        window.open("/#/home/plans/" + id + "/:planId")
    }

    const pieChartOptions = {
        colors: ['#a389d4', '#04a9f5', '#1dc4e9']
    };

    const barChartOptions = {
        chart: {
            colors: ['#a9b7d0']
        },
        chartLanguage: "de"
    };

    const additionalColumn = {
        Header: ' ',
        Cell: ({ row }) => (
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-end max-w-max lg:max-w-none ml-auto">
                <button onClick={e => viewMeasurements(row.original.id)} className="button without-icon justify-center whitespace-nowrap text-xs !px-4 !py-3 m-1 bg-secondaryGradient"> Pogledaj mere</button>
                <button onClick={e => viewPlans(row.original.id)} className="button without-icon justify-center whitespace-nowrap text-xs !px-4 !py-3 m-1 bg-secondaryGradient"> Pogledaj planove</button>
                <button onClick={e => createPlan(row.original.id)} className="button without-icon justify-center whitespace-nowrap text-xs !px-4 !py-3 m-1 bg-secondaryGradient"> Napravi novi plan</button>
            </div>
        )
    }

    const openModal = (row) => {
        setUserData(row.original);
        setIsOpen(true);
        setModalTitle('Izmeni klijenta');
    };


    const addClient = (userData, formValues) => {
        let tempForm = { ...formValues, id: userData.id }
        if (tempForm.id) {
            ClientService.updateClient(tempForm).then(() => {
                setShouldLoad(true)
            });
        } else {
            ClientService.addClient(tempForm).then(() => {
                setShouldLoad(true)
            });
        }

    }

    const barChartClientsLabel = [["Mesec", "Klijenti"]];
    const barChartPlansLabel = [["Mesec", "Kreirani Planovi"]];

    return (
        <>
            <AddUserButton setIsOpen={setIsOpen} setUserData={setUserData} setModalTitle={setModalTitle} buttonText={buttonText} />
            {isOpen &&
                <Modal setIsOpen={setIsOpen} width="w-full sm:w-full md:max-w-[80vw] lg:max-w-[70vw]" modalContent={<ClientsForm setIsOpen={setIsOpen} userData={userData} modalTitle={modalTitle} addClient={addClient} />} />
            }
            <div className="w-full lg:w-100  p-5 bg-white shadow-table rounded mt-9">
                <form >
                    <div className='flex flex-col sm:flex-row -mx-4'>
                        <div className="input-group w-full lg:w-3/5 p-4">
                            <label className="font-medium text-xs text-gray-500">Send invite to email</label>
                            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field lg:w-60" />
                            {hasError && isNullOrWhitespace(email) && <span className="input-error">Please enter email.</span>}
                        </div>
                        <div className='lg:w-2/5 sm:p-4'>
                            <button type="submit" disabled style={{ display: "none" }} aria-hidden="true"></button>
                            <button type="submit" className="button without-icon bg-secondaryGradient mx-auto mt-2 sm:mt-5" onClick={e => handleFormSubmit(e)}>
                                Prosledi
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div className="flex flex-wrap -mx-4 mt-5">
                <div className="w-full xl:w-3/5 p-4  ">
                    <div className="w-full  p-5 pt-px bg-white shadow-table rounded">
                        {clientsData !== null ?
                            <Table columnsProp={COLUMNS} dataProp={clientsData} additionalColumn={additionalColumn} openModal={openModal} setIsOpen={setIsOpen} />
                            : null}
                    </div>
                </div>
                <div className="w-full xl:w-2/5 p-4">
                    <div className="w-full  p-5 bg-white shadow-table rounded">
                        <h3>Broj kreiranih planova u poslednjih 6 meseci</h3>
                        <div className="mt-5">
                            {plansNumberData !== null ?
                                <Chart
                                    chartType="Bar"
                                    width="100%"
                                    height="335px"
                                    data={plansNumberData}
                                    options={barChartOptions}
                                /> : null}
                        </div>
                    </div>
                    <div className="w-full mt-8 p-5 bg-white shadow-table rounded">
                        <h3>Broj klijenata u poslednjih 6 meseci</h3>
                        <div className="mt-5">
                            {clientsNumberData !== null ?
                                <Chart
                                    chartType="Bar"
                                    width="100%"
                                    height="340px"
                                    data={clientsNumberData}
                                    options={barChartOptions}
                                /> : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dashboard;